import { CommonModule } from '@angular/common';
import { ComponentRef, Directive, Input, NgModule, TemplateRef, ViewContainerRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * This directive swaps the attached template for a spinner based upon some expression
 * @example `<mat-icon *comSpinner="isLoading"></mat-icon>`
 */
@Directive({
  selector: '[comSpinner]',
})
export class SpinnerDirective {
  #color: ThemePalette = 'accent';
  #diameter: number = 18;
  #isSpinning = null; // unset by default, this forces it to evaluate upon first render.
  #spinner: MatProgressSpinner = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  @Input()
  set comSpinnerColor(color: ThemePalette) {
    this.#color = color;
    if (this.#spinner) {
      this.#spinner.color = color;
    }
  }

  @Input()
  set comSpinnerDiameter(diameter: number) {
    this.#diameter = diameter;
    if (this.#spinner) {
      this.#spinner.diameter = diameter;
    }
  }

  @Input() set comSpinner(condition: boolean) {
    if (!!condition !== this.#isSpinning) {
      this.#spinner = null;
      this.viewContainer.clear();
      this.#isSpinning = condition;
      if (!condition) {
        // Render the template
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else if (condition) {
        this.addSpinner();
      }
    }
  }

  private addSpinner() {
    const { instance }: ComponentRef<MatProgressSpinner> = this.viewContainer.createComponent(MatProgressSpinner);
    instance.diameter = this.#diameter;
    instance.color = this.#color;
    instance.mode = 'indeterminate';
    instance._elementRef.nativeElement.classList.add('com-spinner');
    this.#spinner = instance;
  }
}

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule],
  declarations: [SpinnerDirective],
  exports: [SpinnerDirective, MatProgressSpinnerModule],
})
export class SpinnerModule { }
